import breadCrumbs from "./breadCrumbs/breadCrumbs.vue";
import scrollBtn from "./scrollBtn/scrollBtn.vue";
import multiSelect from "./multiSelect/multiSelect.vue";
import modalWindow from "./modalWindow/modalWindow.vue";
import multiSelectWithSearch from "./multiSelectWithSearch/multiSelectWithSearch.vue";

export default [
    breadCrumbs, scrollBtn, multiSelect, modalWindow, multiSelectWithSearch
];
